import React from "react";
import { useAuth } from "../context/AuthContext";

const GroupLeave = ({
  setGroupLeavePopUp,
  emitWithAck,
  setChats,
  activeChat,
  setActiveChat,
}) => {
  const { userId, userInfo } = useAuth();

  const amITheOnlyAdmin =
    activeChat.admin.includes(String(userId)) && activeChat.admin.length === 1;

  const leaveGroup = async () => {
    try {
      const data = await emitWithAck("group:leave", {
        groupId: activeChat._id,
        memberName: userInfo.username,
      });
      setGroupLeavePopUp(false);
      setChats((prev) => {
        if (!prev) return prev;
        return prev.filter(
          (frienfInfo) => frienfInfo?.group?._id !== activeChat._id,
        );
      });

      setActiveChat(null);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      onClick={(e) => {
        setGroupLeavePopUp(false);
        e.stopPropagation();
      }}
      className="fixed inset-0 bg-black/80 z-50 flex justify-center items-center"
    >
      <div
        className="w-[50dvw] h-[20dvh] bg-white p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          {amITheOnlyAdmin
            ? "You are the only admin. Make someone else an admin to leave"
            : "Are you sure you want to leave?"}
        </div>
        {!amITheOnlyAdmin && (
          <div className="flex justify-end gap-1 ">
            <button
              onClick={() => setGroupLeavePopUp(false)}
              className="border border-gray-400 p-1 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={leaveGroup}
              className={`${amITheOnlyAdmin ? "cursor-not-allowed" : ""} p-1 bg-orange-400 rounded-lg`}
              disabled={amITheOnlyAdmin}
            >
              Leave
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupLeave;
